
import { Link } from "react-router-dom";
import { Heart, MapPin } from "lucide-react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-cottage-50 border-t border-cottage-100">
      <div className="max-w-7xl mx-auto px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div className="space-y-4">
            <h3 className="text-xl font-semibold text-cottage-800">
              The Cottage <span className="text-cottage-500 font-normal text-base">at Flowerpot</span>
            </h3>
            <p className="text-cottage-600 max-w-xs">
              A peaceful 4 bedroom rural Tasmania accommodation sleeping 8 guests. Perfect for multi-generational family holidays, artist retreats, writer's retreats, musician retreats, and executive getaways. Ideal for mainland Australia to Tasmania travellers.
            </p>
            <p className="text-cottage-500 text-sm mt-2 italic">
              Flowerpot family holiday house | Rural Tasmania accommodation
            </p>
            <div className="pt-2 flex items-center text-cottage-500 text-sm">
              <Heart size={14} className="mr-2 text-cottage-500" />
              <span>Made with love in Tasmania</span>
            </div>
          </div>

          <div className="space-y-4">
            <h3 className="text-xl font-semibold text-cottage-800">Location</h3>
            <div className="space-y-3">
              <div className="flex items-start">
                <MapPin size={18} className="mr-3 text-cottage-600 mt-1" />
                <span className="text-cottage-600">Flowerpot, Tasmania, Australia</span>
              </div>
            </div>
          </div>

          <div className="space-y-4">
            <h3 className="text-xl font-semibold text-cottage-800">Quick Links</h3>
            <div className="flex flex-col space-y-2">
              <Link to="/" className="text-cottage-600 hover:text-cottage-800 transition-colors">
                Home
              </Link>
              <Link to="/details" className="text-cottage-600 hover:text-cottage-800 transition-colors">
                Property Details
              </Link>
              <Link to="/gallery" className="text-cottage-600 hover:text-cottage-800 transition-colors">
                Gallery
              </Link>
              <Link to="/reviews" className="text-cottage-600 hover:text-cottage-800 transition-colors">
                Guest Reviews
              </Link>
              <Link to="/contact" className="text-cottage-600 hover:text-cottage-800 transition-colors">
                Contact & Enquiry
              </Link>
              <Link to="/book" className="text-cottage-600 hover:text-cottage-800 transition-colors">
                Book
              </Link>
            </div>
          </div>
        </div>

        <div className="border-t border-cottage-100 mt-10 pt-6 flex flex-col md:flex-row justify-between items-center">
          <p className="text-cottage-500 text-sm order-2 md:order-1 mt-4 md:mt-0">
            © {currentYear} The Cottage at Flowerpot. All rights reserved.
          </p>
          <div className="flex space-x-6 order-1 md:order-2">
            <a href="#" rel="nofollow" className="text-cottage-600 hover:text-cottage-800 transition-colors">
              Privacy Policy
            </a>
            <a href="#" rel="nofollow" className="text-cottage-600 hover:text-cottage-800 transition-colors">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
